<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation
    class="bg-card dark:bg-gray-900 print:hidden"
    [appearance]="'thin'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.compact"
    [opened]="!isScreenSmall"
>
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex h-20 items-center justify-center">
            <img class="w-12" src="images/logo/dp_logo.png" alt="District Printing" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<div class="flex w-full min-w-0 flex-auto flex-col">

    <mat-drawer-container class="flex-auto" [hasBackdrop]="false">

        <mat-drawer-content class="flex flex-col">
            <div
                class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 lg:pr-3 print:hidden"
            >
                <div class="flex items-center space-x-2 pr-2">
                    <button
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                   <!--  <button
                        class="hidden md:inline-flex"
                        mat-icon-button
                        (click)="toggleNavigationAppearance()"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>
                    </button> -->
                </div>
                <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
                    <button mat-icon-button (click)="openAddUserDrawer()" [matTooltip]="'Add new user'">
                        <mat-icon [svgIcon]="'heroicons_outline:user-plus'"></mat-icon>
                    </button>
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <messages></messages>
                    <timeline-activities></timeline-activities>
                    <updates-required></updates-required>
                    <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                    </button>
                    <user></user>
                </div>
            </div>

            <div class="flex flex-auto flex-col lg:pr-[var(--quick-chat-rail-width)]">
                @if (true) {
                    <router-outlet></router-outlet>
                }
            </div>

        </mat-drawer-content>

        <mat-drawer #addUserDrawer class="w-full md:w-160" [mode]="'over'" [position]="'start'">
            <div class="p-8">
                <div class="flex items-center justify-between">
                    <h2 class="text-2xl font-semibold">New Customer</h2>
                    <button mat-icon-button (click)="addUserDrawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
                @defer (on timer(1s)) {
                    <quick-add-user [customerMode]="true" (closeDrawer)="addUserDrawer.close()"></quick-add-user>
                }
            </div>
        </mat-drawer>

    </mat-drawer-container>

</div>

<quick-chat #quickChat="quickChat"></quick-chat>